import 'ag-grid-community/styles/ag-grid.css'
import 'ag-grid-community/styles/ag-theme-alpine.css'
import 'ag-grid-community/styles/ag-theme-quartz.css'
import {
  CheckboxEditorModule,
  ClientSideRowModelApiModule,
  ClientSideRowModelModule,
  ColumnApiModule,
  CustomEditorModule,
  InfiniteRowModelModule,
  ModuleRegistry,
  NumberFilterModule,
  provideGlobalGridOptions,
  RenderApiModule,
  RowAutoHeightModule,
  RowStyleModule,
  TextFilterModule,
  TooltipModule,
  ValidationModule,
} from 'ag-grid-community'
import {
  CellStyleModule,
  ColumnsToolPanelModule,
  DateFilterModule,
  ExcelExportModule,
  FiltersToolPanelModule,
  LicenseManager,
  MasterDetailModule,
  NumberEditorModule,
  PaginationModule,
  PivotModule,
  RichSelectModule,
  RowApiModule,
  RowGroupingPanelModule,
  RowSelectionModule,
  SetFilterModule,
  SideBarModule,
  StatusBarModule,
  TextEditorModule,
} from 'ag-grid-enterprise'

export const agGridInit = () => {
  // Set the license key for ag-grid-enterprise
  LicenseManager.setLicenseKey(
    'Using_this_{AG_Grid}_Enterprise_key_{AG-101240}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{Polymer_Consulting_Limited}_is_granted_a_{Single_Application}_Developer_License_for_the_application_{Praxis}_only_for_{1}_Front-End_JavaScript_developer___All_Front-End_JavaScript_developers_working_on_{Praxis}_need_to_be_licensed___{Praxis}_has_not_been_granted_a_Deployment_License_Add-on___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{7_June_2027}____[v3]_[01]_MTgxMjMyMjgwMDAwMA==253b71b6c4078336f6059f3688dbe3de',
  )

  provideGlobalGridOptions({ theme: 'legacy' })
  ModuleRegistry.registerModules([
    ClientSideRowModelModule,
    ClientSideRowModelApiModule,
    PivotModule,
    PaginationModule,
    ValidationModule,
    DateFilterModule,
    SideBarModule,
    RowGroupingPanelModule,
    RowSelectionModule,
    ColumnsToolPanelModule,
    FiltersToolPanelModule,
    ExcelExportModule,
    TextFilterModule,
    SetFilterModule,
    RichSelectModule,
    TextEditorModule,
    NumberEditorModule,
    RowApiModule,
    CellStyleModule,
    StatusBarModule,
    RenderApiModule,
    CheckboxEditorModule,
    RowStyleModule,
    ColumnApiModule,
    InfiniteRowModelModule,
    RowAutoHeightModule,
    NumberFilterModule,
    CustomEditorModule,
    TooltipModule,
    MasterDetailModule,
  ])
}